import { useEffect, useState } from 'react';

import { flagService } from '../core/services/flagService';
import { CrossSellMenuItems } from '../core/state/order/order.types';
import { getCrossSellMenuItemIds } from '../core/state/order/orderMiddleware';
import { MenuItem, MenuReposnse } from '../weborder/Api';
import { Data as Basket } from '../weborder/BasketControl';

interface UseCrossSellMenuItems {
  data: MenuItem[];
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCrossSellMenuItems = (
  basketItems: Basket['items'],
  menu: MenuReposnse,
  orderTotal: number,
  limit?: number,
): UseCrossSellMenuItems => {
  const [data, setData] = useState<MenuItem[]>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const isCrossSellEnabled = flagService.isFlagOn('crossSell');

  const getCrossSellMenuItems = (
    menuItemIds: CrossSellMenuItems['MenuItemIds'],
  ): MenuItem[] => {
    const menuItems: MenuItem[] = [];
    menu.MenuSections.forEach((section) => {
      section.MenuItems.forEach((item) => {
        const isMenuItemFound = menuItemIds.some(
          (id) => id === item.MenuItemId,
        );
        if (isMenuItemFound) {
          menuItems.push(item);
        }
      });
    });

    return menuItems;
  };

  useEffect(() => {
    const hasMenuData =
      !!menu?.MenuId && basketItems.length > 0 && !!orderTotal;
    if (isCrossSellEnabled && !isSuccess && hasMenuData) {
      const menuItemIds = basketItems.map(
        (basketItem) => basketItem.Item.MenuItemId,
      );

      getCrossSellMenuItemIds(limit || 6, menu.MenuId, menuItemIds, orderTotal)
        .then((response) => getCrossSellMenuItems(response?.MenuItemIds || []))
        .then((menuItems) => setData(menuItems))
        .then(() => setIsSuccess(true))
        .catch(() => setIsError(true))
        .finally(() => setIsLoading(false));
    }
  }, [basketItems.length, limit, menu?.MenuId, orderTotal]);

  return {
    data,
    isError,
    isLoading,
    isSuccess,
  };
};
